import React, { useState } from 'react'
import moment from 'moment'
import DetailsBox, {
  DetailRow,
} from '../../../../../components/Cards/DetailsBox'
import DBSCheck from './DBSCheck'
import MedicalInfo from './MedicalInfo'
//@MUI
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import DrivingLicence from './DrivingLicence'
import Uniform from './Uniform'
import { Box, Chip, Stack } from '@mui/material'
import IDCards from './IDCards'
import ControlledDrugs from './ControlledDrugs'

const DetailsTab = ({ employeeData, loadEmployee }) => {
  const employee = employeeData?.employee
  const driverDetails = employee?.personnelInfo.driving ?? {}
  const address = employee?.personnelInfo.address ?? {}
  const registration = employee?.registrationNumber ?? {}
  const [openAddNew, setOpenAddNew] = useState(false)

  return (
    <Grid container columnSpacing={4} rowSpacing={8} padding={2}>
      <Grid item xs={12} lg={6}>
        <DetailsBox
          title="Personal Details"
          noBorder
          rows={[
            { label: 'Employee Status', value: employee.status ?? '-' },
            { label: 'Pronouns', value: employee?.personnelInfo.pronouns },
            {
              label: 'Nationality',
              value: employee?.personnelInfo.nationality,
            },
            {
              label: 'Date of Birth',
              value: employee?.personnelInfo?.dob
                ? moment(employee?.personnelInfo.dob).format('Do MMMM YYYY')
                : '',
            },
            {
              label: 'BirthPlace',
              value: employee?.personnelInfo?.birthplace ?? '',
            },
            {
              label: 'Address',
              value: `${address.lineOne ? address.lineOne + ',' : ''} ${
                address.lineTwo ? address.lineTwo + ', ' : ''
              } ${address.town ? address.town + ',' : ''} ${
                address.city ? address.city + ',' : ''
              } ${address.county ? address.county + ',' : ''} ${
                address.postCode ? address.postCode : ''
              }`,
              fullWidth: true,
            },
          ]}
        >
          <DetailRow label="Vehicles">
            <Stack direction="row" gap={1}>
              {(employee?.personnelInfo?.vehicleRegistrations ?? []).map(
                (plate, i) => (
                  <Chip
                    key={i}
                    label={String(plate).toUpperCase()}
                    sx={{
                      '& .MuiChip-label': {
                        px: 0.5,
                        textTransform: 'uppercase',
                      },
                      '& .MuiChip-deleteIcon': {
                        color: '#111',
                        ml: 1,
                        '&:hover': { color: '#000' },
                      },
                      bgcolor: '#FFD307',
                      color: '#111',
                      borderRadius: 1,
                      letterSpacing: '0.08em',
                      fontFamily: `"UKnumberplate", "Charles Wright", "Arial Black", Arial, sans-serif`,
                      px: 1.2,
                      height: 34,
                    }}
                    variant="filled"
                  />
                ),
              )}
            </Stack>
          </DetailRow>
        </DetailsBox>
      </Grid>
      <DrivingLicence
        driverDetails={employee.personnelInfo.driving}
        latestCheck={employee.latestDrivingLicenceCheck}
        employeeID={employee._id}
        loadEmployee={loadEmployee}
      />
      <DBSCheck employeeData={employeeData} loadEmployee={loadEmployee} />
      {registration.number && (
        <Grid item xs={12} lg={6}>
          <DetailsBox
            title="Professional Registration"
            noBorder
            rows={[
              {
                label: 'Council',
                value: registration?.body?.toUpperCase() ?? '',
              },
              {
                label: 'Number',
                value: registration?.number?.toUpperCase() ?? '',
              },
              {
                label: 'Renewal',
                value: moment(registration.renewDate).format('DD/MM/YYYY'),
              },
            ]}
            buttonRight={
              registration?.body?.toUpperCase() === 'HCPC' &&
              registration.number.substring(0, 2)?.toUpperCase() === 'PA' && (
                <Button
                  size="small"
                  variant="outlined"
                  color="anPurple"
                  onClick={() =>
                    window.open(
                      `https://www.hcpc-uk.org/check-the-register/professional-registration-detail/?query=${registration.number.toUpperCase()}&profession=PA`,
                    )
                  }
                >
                  Check Register
                </Button>
              )
            }
          />
        </Grid>
      )}
      {/* <MedicalInfo /> */}
      {/* <Uniform uniform={employee?.uniform} /> */}
      {employee.carriesControlledDrugs && (
        <ControlledDrugs employeeID={employee._id} />
      )}
      <IDCards employeeID={employee._id} />
    </Grid>
  )
}

export default DetailsTab
